"use client";

export const APP_ZOOM_KEY = "bp-zoom-interface";
export const APP_ZOOM_OPCOES = [100, 95, 90, 85, 80, 75] as const;
export type AppZoom = (typeof APP_ZOOM_OPCOES)[number];

export function normalizarAppZoom(valor?: string | number | null): AppZoom {
  const zoom = Number(valor);
  return APP_ZOOM_OPCOES.includes(zoom as AppZoom) ? (zoom as AppZoom) : 100;
}

export function lerAppZoomSalvo(): AppZoom {
  if (typeof window === "undefined") return 100;
  return normalizarAppZoom(window.localStorage.getItem(APP_ZOOM_KEY));
}

export function aplicarAppZoom(zoom: AppZoom = lerAppZoomSalvo()) {
  if (typeof document === "undefined") return;

  const zoomNormalizado = normalizarAppZoom(zoom);
  const raiz = document.documentElement;

  raiz.style.removeProperty("zoom");
  raiz.style.removeProperty("--app-zoom");
  raiz.style.removeProperty("--app-zoom-inverse");
  raiz.style.fontSize = `${zoomNormalizado}%`;
  delete raiz.dataset.appZoom;

  if (document.body) {
    document.body.style.removeProperty("zoom");
    delete document.body.dataset.appZoom;
  }
}
